var _rect, _mask, _path, _mask2, _path2, _circle, _circle2, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7,
    width: 34,
    height: 27,
    rx: 4,
    stroke: "#7956C3",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1781_160870",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8191 18.5056C32.2858 18.1637 32.391 17.5036 31.9999 17.0773C31.2138 16.2206 30.2751 15.5132 29.2287 14.993C27.8687 14.317 26.3664 13.9769 24.8479 14.0012C23.3293 14.0255 21.8387 14.4136 20.5011 15.1328C19.4719 15.6862 18.5563 16.4233 17.798 17.3047C17.4208 17.7433 17.5471 18.3997 18.0245 18.7265C18.502 19.0532 19.1489 18.9248 19.5397 18.4982C20.0993 17.8873 20.7592 17.3728 21.4933 16.9781C22.5359 16.4175 23.6978 16.115 24.8814 16.096C26.0651 16.0771 27.236 16.3422 28.2961 16.8691C29.0424 17.2401 29.7185 17.7333 30.2973 18.3259C30.7016 18.7398 31.3523 18.8474 31.8191 18.5056Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8191 18.5056C32.2858 18.1637 32.391 17.5036 31.9999 17.0773C31.2138 16.2206 30.2751 15.5132 29.2287 14.993C27.8687 14.317 26.3664 13.9769 24.8479 14.0012C23.3293 14.0255 21.8387 14.4136 20.5011 15.1328C19.4719 15.6862 18.5563 16.4233 17.798 17.3047C17.4208 17.7433 17.5471 18.3997 18.0245 18.7265C18.502 19.0532 19.1489 18.9248 19.5397 18.4982C20.0993 17.8873 20.7592 17.3728 21.4933 16.9781C22.5359 16.4175 23.6978 16.115 24.8814 16.096C26.0651 16.0771 27.236 16.3422 28.2961 16.8691C29.0424 17.2401 29.7185 17.7333 30.2973 18.3259C30.7016 18.7398 31.3523 18.8474 31.8191 18.5056Z",
    stroke: "#7956C3",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1_1781_160870)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_1781_160870",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.902 20.9599C29.0605 20.5502 28.9058 20.0857 28.5428 19.8384C27.3456 19.0229 26.562 18.3871 24.9465 18.4329C23.3679 18.4776 22.3883 19.1335 21.2083 19.988C20.8139 20.2736 20.7146 20.822 20.9847 21.2271C21.2667 21.6501 21.8391 21.7513 22.2484 21.4497C23.0774 20.839 23.9088 20.2839 24.9465 20.2545C26.2135 20.2545 26.9002 20.7768 27.6038 21.3371C28.0558 21.697 28.6936 21.4989 28.902 20.9599Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9465 18.4329L24.8898 16.4337L24.9465 18.4329ZM24.9465 20.2545L24.9465 18.2545L24.9181 18.2545L24.8898 18.2553L24.9465 20.2545ZM22.2484 21.4497L21.0621 19.8395L22.2484 21.4497ZM20.9847 21.2271L19.3207 22.3367L20.9847 21.2271ZM27.6038 21.3371L26.3579 22.9017L27.6038 21.3371ZM28.5428 19.8384L29.6687 18.1854L28.5428 19.8384ZM28.902 20.9599L27.0366 20.2385L28.902 20.9599ZM29.6687 18.1854C28.5544 17.4264 27.2496 16.3669 24.8898 16.4337L25.0031 20.4321C25.501 20.418 25.792 20.5021 26.0566 20.6255C26.4151 20.7925 26.7286 21.0226 27.4168 21.4913L29.6687 18.1854ZM24.8898 16.4337C22.6566 16.497 21.2462 17.4911 20.0352 18.3682L22.3814 21.6079C23.5303 20.7758 24.0791 20.4583 25.0031 20.4321L24.8898 16.4337ZM23.4347 23.0599C24.2839 22.4343 24.6575 22.2635 25.0031 22.2537L24.8898 18.2553C23.16 18.3043 21.8709 19.2437 21.0621 19.8395L23.4347 23.0599ZM24.9465 22.2545C25.2801 22.2545 25.4728 22.3176 25.621 22.3888C25.8106 22.4797 25.9979 22.615 26.3579 22.9017L28.8496 19.7725C28.0764 19.1568 26.9297 18.2545 24.9465 18.2545L24.9465 22.2545ZM19.3207 22.3367C20.2344 23.707 22.1044 24.04 23.4347 23.0599L21.0621 19.8395C21.5739 19.4625 22.299 19.5931 22.6487 20.1176L19.3207 22.3367ZM20.0352 18.3682C18.7731 19.2823 18.4528 21.0351 19.3207 22.3367L22.6487 20.1176C22.9763 20.6089 22.8548 21.265 22.3814 21.6079L20.0352 18.3682ZM26.3579 22.9017C27.9505 24.1698 30.1118 23.3764 30.7673 21.6813L27.0366 20.2385C27.2753 19.6213 28.1611 19.2243 28.8496 19.7725L26.3579 22.9017ZM27.4168 21.4913C27.0439 21.2373 26.8458 20.7318 27.0366 20.2385L30.7673 21.6813C31.2751 20.3685 30.7678 18.9341 29.6687 18.1854L27.4168 21.4913Z",
    fill: "#7956C3",
    mask: "url(#path-3-inside-2_1781_160870)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 27.5,
    r: 1.5,
    fill: "#7956C3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 23.5,
    r: 1.5,
    fill: "#7956C3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 38,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#7956C3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 40,
    width: 6,
    height: 2,
    rx: 1,
    transform: "rotate(-90 18.5 40)",
    fill: "#7956C3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 40,
    width: 6,
    height: 2,
    rx: 1,
    transform: "rotate(-90 28.5 40)",
    fill: "#7956C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default __webpack_public_path__ + "static/media/monitoring.f52754b653216c32ea1ea60a762bdb2a.svg";
export { ForwardRef as ReactComponent };